/**
 * Wave 27 — Country SEO i18n
 * New: Slovenia 🇸🇮, Cyprus 🇨🇾, Mozambique 🇲🇿
 * Gap-fill: Colombia 🇨🇴 (missing ZH/JA/KO/SV/DA), Nigeria 🇳🇬 (missing ZH/JA/KO/SV/DA)
 */
import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE27: CountrySEOMap = {

  slovenia: {
    fr: {
      title: 'Centre d\'appel Slovénie | Service Client Multilingue | Call IT Dev',
      description: 'Externalisez votre centre d\'appel en Slovénie : agents multilingues, fuseau CET, CSAT 95%, dès 8 €/h. 45% d\'économies.',
      heroTitle: 'Centre d\'appel pour la Slovénie — Support multilingue depuis Casablanca',
      heroSubtitle: 'Service client premium pour le marché slovène. Fuseau CET, 45% moins cher.',
    },
    es: {
      title: 'Call Center Eslovenia | Atención al Cliente Multilingüe | Call IT Dev',
      description: 'Call center para Eslovenia: agentes multilingües, zona CET, CSAT 95%, desde 8 €/h. 45% ahorro.',
      heroTitle: 'Call Center para Eslovenia — Soporte Multilingüe desde Casablanca',
      heroSubtitle: 'Atención premium para el mercado esloveno. 45% más barato.',
    },
    de: {
      title: 'Call Center Slowenien | Mehrsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Slowenien: mehrsprachige Agenten, CET-Zeitzone, CSAT 95%, ab 8 €/h. 45% Ersparnis.',
      heroTitle: 'Call Center für Slowenien — Mehrsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den slowenischen Markt. 45% günstiger.',
    },
    ar: {
      title: 'مركز اتصال سلوفينيا | خدمة عملاء متعددة اللغات | Call IT Dev',
      description: 'مركز اتصال لسلوفينيا: وكلاء متعددو اللغات، منطقة CET، CSAT 95%، من 8 €/ساعة. توفير 45%.',
      heroTitle: 'مركز اتصال لسلوفينيا — دعم متعدد اللغات من الدار البيضاء',
      heroSubtitle: 'خدمة عملاء متميزة للسوق السلوفيني. توفير 45%.',
    },
    it: {
      title: 'Call Center Slovenia | Assistenza Multilingue | Call IT Dev',
      description: 'Call center per la Slovenia: agenti multilingui, fuso CET, CSAT 95%, da 8 €/h. 45% risparmio.',
      heroTitle: 'Call Center per la Slovenia — Supporto Multilingue da Casablanca',
      heroSubtitle: 'Assistenza premium per il mercato sloveno. 45% in meno.',
    },
    pt: {
      title: 'Call Center Eslovénia | Atendimento Multilíngue | Call IT Dev',
      description: 'Call center para Eslovénia: agentes multilíngues, fuso CET, CSAT 95%, a partir de 8 €/h. 45% economia.',
      heroTitle: 'Call Center para Eslovénia — Suporte Multilíngue de Casablanca',
      heroSubtitle: 'Atendimento premium para o mercado esloveno. 45% mais barato.',
    },
    nl: {
      title: 'Callcenter Slovenië | Meertalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Slovenië: meertalige agenten, CET-tijdzone, CSAT 95%, vanaf 8 €/u. 45% besparing.',
      heroTitle: 'Callcenter voor Slovenië — Meertalige Support vanuit Casablanca',
      heroSubtitle: 'Premium klantenservice voor de Sloveense markt. 45% goedkoper.',
    },
    pl: {
      title: 'Call Center Słowenia | Wielojęzyczna Obsługa Klienta | Call IT Dev',
      description: 'Call center dla Słowenii: wielojęzyczni agenci, strefa CET, CSAT 95%, od 8 €/h. 45% oszczędności.',
      heroTitle: 'Call Center dla Słowenii — Wielojęzyczne Wsparcie z Casablanki',
      heroSubtitle: 'Premiumowa obsługa klienta dla rynku słoweńskiego. 45% taniej.',
    },
    tr: {
      title: 'Slovenya Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'Slovenya için çağrı merkezi: çok dilli ajanlar, CET saat dilimi, CSAT %95, 8 €/saatten başlayan.',
      heroTitle: 'Slovenya İçin Çağrı Merkezi — Kazablanka\'dan Çok Dilli Destek',
      heroSubtitle: 'Slovenya pazarı için premium müşteri deneyimi. %45 daha ucuz.',
    },
    sv: {
      title: 'Callcenter Slovenien | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Slovenien: flerspråkiga agenter, CET-tidszon, CSAT 95%, från 8 €/h. 45% besparing.',
      heroTitle: 'Callcenter för Slovenien — Flerspråkigt Stöd från Casablanca',
      heroSubtitle: 'Premium kundtjänst för den slovenska marknaden. 45% billigare.',
    },
    da: {
      title: 'Callcenter Slovenien | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Slovenien: flersprogede agenter, CET-tidszone, CSAT 95%, fra 3 €/t. 45% besparelse.',
      heroTitle: 'Callcenter til Slovenien — Flersproget Support fra Casablanca',
      heroSubtitle: 'Premium kundeservice for det slovenske marked. 45% billigere.',
    },
    zh: {
      title: '斯洛文尼亚呼叫中心 | 多语言客服外包 | Call IT Dev',
      description: '斯洛文尼亚呼叫中心外包：多语言座席，CET时区，CSAT 95%，3€/小时起。节省45%。',
      heroTitle: '斯洛文尼亚呼叫中心 — 卡萨布兰卡多语言支持',
      heroSubtitle: '以nearshore价格提供斯洛文尼亚市场优质客户服务。节省45%。',
    },
    ja: {
      title: 'スロベニアコールセンター | 多言語カスタマーサポート | Call IT Dev',
      description: 'スロベニア向けコールセンター：多言語対応、CET時間帯、CSAT 95%、3€/時間〜。45%コスト削減。',
      heroTitle: 'スロベニア向けコールセンター — カサブランカからの多言語サポート',
      heroSubtitle: 'スロベニア市場向けプレミアム顧客サービス。45%低コスト。',
    },
    ko: {
      title: '슬로베니아 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '슬로베니아 콜센터: 다국어 상담원, CET 시간대, CSAT 95%, 3€/시간부터. 45% 절감.',
      heroTitle: '슬로베니아 콜센터 — 카사블랑카에서 다국어 지원',
      heroSubtitle: '슬로베니아 시장을 위한 프리미엄 고객 서비스. 45% 저렴.',
    },
    ru: {
      title: 'Колл-центр Словения | Многоязычное обслуживание | Call IT Dev',
      description: 'Колл-центр для Словении: многоязычные агенты, часовой пояс CET, CSAT 95%, от 3 €/ч. Экономия 45%.',
      heroTitle: 'Колл-центр для Словении — Многоязычная поддержка из Касабланки',
      heroSubtitle: 'Премиум-обслуживание для словенского рынка. На 45% дешевле.',
    },
  },

  cyprus: {
    fr: {
      title: 'Centre d\'appel Chypre | Service Client Multilingue | Call IT Dev',
      description: 'Externalisez votre centre d\'appel à Chypre : agents multilingues, fuseau EET, CSAT 95%, dès 8 €/h. 50% d\'économies.',
      heroTitle: 'Centre d\'appel pour Chypre — Support multilingue depuis Casablanca',
      heroSubtitle: 'Service client premium pour le marché chypriote. Fuseau EET, 50% moins cher.',
    },
    es: {
      title: 'Call Center Chipre | Atención Multilingüe | Call IT Dev',
      description: 'Call center para Chipre: agentes multilingües, zona EET, CSAT 95%, desde 8 €/h. 50% ahorro.',
      heroTitle: 'Call Center para Chipre — Soporte Multilingüe desde Casablanca',
      heroSubtitle: 'Atención premium para el mercado chipriota. 50% más barato.',
    },
    de: {
      title: 'Call Center Zypern | Mehrsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Zypern: mehrsprachige Agenten, EET-Zeitzone, CSAT 95%, ab 8 €/h. 50% Ersparnis.',
      heroTitle: 'Call Center für Zypern — Mehrsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den zypriotischen Markt. 50% günstiger.',
    },
    ar: {
      title: 'مركز اتصال قبرص | خدمة عملاء متعددة اللغات | Call IT Dev',
      description: 'مركز اتصال لقبرص: وكلاء متعددو اللغات، منطقة EET، CSAT 95%، من 8 €/ساعة. توفير 50%.',
      heroTitle: 'مركز اتصال لقبرص — دعم متعدد اللغات من الدار البيضاء',
      heroSubtitle: 'خدمة عملاء متميزة للسوق القبرصي. توفير 50%.',
    },
    it: {
      title: 'Call Center Cipro | Assistenza Multilingue | Call IT Dev',
      description: 'Call center per Cipro: agenti multilingui, fuso EET, CSAT 95%, da 8 €/h. 50% risparmio.',
      heroTitle: 'Call Center per Cipro — Supporto Multilingue da Casablanca',
      heroSubtitle: 'Assistenza premium per il mercato cipriota. 50% in meno.',
    },
    pt: {
      title: 'Call Center Chipre | Atendimento Multilíngue | Call IT Dev',
      description: 'Call center para Chipre: agentes multilíngues, fuso EET, CSAT 95%, a partir de 8 €/h. 50% economia.',
      heroTitle: 'Call Center para Chipre — Suporte Multilíngue de Casablanca',
      heroSubtitle: 'Atendimento premium para o mercado cipriota. 50% mais barato.',
    },
    nl: {
      title: 'Callcenter Cyprus | Meertalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Cyprus: meertalige agenten, EET-tijdzone, CSAT 95%, vanaf 8 €/u. 50% besparing.',
      heroTitle: 'Callcenter voor Cyprus — Meertalige Support vanuit Casablanca',
      heroSubtitle: 'Premium klantenservice voor de Cypriotische markt. 50% goedkoper.',
    },
    pl: {
      title: 'Call Center Cypr | Wielojęzyczna Obsługa Klienta | Call IT Dev',
      description: 'Call center dla Cypru: wielojęzyczni agenci, strefa EET, CSAT 95%, od 8 €/h. 50% oszczędności.',
      heroTitle: 'Call Center dla Cypru — Wielojęzyczne Wsparcie z Casablanki',
      heroSubtitle: 'Premiumowa obsługa klienta dla rynku cypryjskiego. 50% taniej.',
    },
    tr: {
      title: 'Kıbrıs Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'Kıbrıs için çağrı merkezi: çok dilli ajanlar, EET saat dilimi, CSAT %95, 8 €/saatten başlayan.',
      heroTitle: 'Kıbrıs İçin Çağrı Merkezi — Kazablanka\'dan Çok Dilli Destek',
      heroSubtitle: 'Kıbrıs pazarı için premium müşteri deneyimi. %50 daha ucuz.',
    },
    sv: {
      title: 'Callcenter Cypern | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Cypern: flerspråkiga agenter, EET-tidszon, CSAT 95%, från 8 €/h. 50% besparing.',
      heroTitle: 'Callcenter för Cypern — Flerspråkigt Stöd från Casablanca',
      heroSubtitle: 'Premium kundtjänst för den cypriotiska marknaden. 50% billigare.',
    },
    da: {
      title: 'Callcenter Cypern | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Cypern: flersprogede agenter, EET-tidszone, CSAT 95%, fra 3 €/t. 50% besparelse.',
      heroTitle: 'Callcenter til Cypern — Flersproget Support fra Casablanca',
      heroSubtitle: 'Premium kundeservice for det cypriotiske marked. 50% billigere.',
    },
    zh: {
      title: '塞浦路斯呼叫中心 | 多语言客服外包 | Call IT Dev',
      description: '塞浦路斯呼叫中心外包：多语言座席，EET时区，CSAT 95%，3€/小时起。节省50%。',
      heroTitle: '塞浦路斯呼叫中心 — 卡萨布兰卡多语言支持',
      heroSubtitle: '以nearshore价格提供塞浦路斯市场优质客户服务。节省50%。',
    },
    ja: {
      title: 'キプロスコールセンター | 多言語カスタマーサポート | Call IT Dev',
      description: 'キプロス向けコールセンター：多言語対応、EET時間帯、CSAT 95%、3€/時間〜。50%コスト削減。',
      heroTitle: 'キプロス向けコールセンター — カサブランカからの多言語サポート',
      heroSubtitle: 'キプロス市場向けプレミアム顧客サービス。50%低コスト。',
    },
    ko: {
      title: '키프로스 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '키프로스 콜센터: 다국어 상담원, EET 시간대, CSAT 95%, 3€/시간부터. 50% 절감.',
      heroTitle: '키프로스 콜센터 — 카사블랑카에서 다국어 지원',
      heroSubtitle: '키프로스 시장을 위한 프리미엄 고객 서비스. 50% 저렴.',
    },
    ru: {
      title: 'Колл-центр Кипр | Многоязычное обслуживание | Call IT Dev',
      description: 'Колл-центр для Кипра: многоязычные агенты, часовой пояс EET, CSAT 95%, от 3 €/ч. Экономия 50%.',
      heroTitle: 'Колл-центр для Кипра — Многоязычная поддержка из Касабланки',
      heroSubtitle: 'Премиум-обслуживание для кипрского рынка. На 50% дешевле.',
    },
  },

  mozambique: {
    fr: {
      title: 'Centre d\'appel Mozambique | Service Client Lusophone | Call IT Dev',
      description: 'Externalisez votre centre d\'appel au Mozambique : agents lusophones, fuseau CAT, CSAT 95%, dès 3 $/h. 80% d\'économies.',
      heroTitle: 'Centre d\'appel pour le Mozambique — Support lusophone depuis Casablanca',
      heroSubtitle: 'Service client premium en portugais pour le marché mozambicain. 80% moins cher.',
    },
    es: {
      title: 'Call Center Mozambique | Atención Lusófona | Call IT Dev',
      description: 'Call center para Mozambique: agentes lusófonos, zona CAT, CSAT 95%, desde 3 $/h. 80% ahorro.',
      heroTitle: 'Call Center para Mozambique — Soporte Lusófono desde Casablanca',
      heroSubtitle: 'Atención premium para el mercado mozambiqueño. 80% más barato.',
    },
    de: {
      title: 'Call Center Mosambik | Portugiesischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Mosambik: portugiesischsprachige Agenten, CAT-Zeitzone, CSAT 95%, ab 3 $/h. 80% Ersparnis.',
      heroTitle: 'Call Center für Mosambik — Portugiesischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den mosambikanischen Markt. 80% günstiger.',
    },
    ar: {
      title: 'مركز اتصال موزمبيق | خدمة عملاء بالبرتغالية | Call IT Dev',
      description: 'مركز اتصال لموزمبيق: وكلاء لوسوفونيون، منطقة CAT، CSAT 95%، من 3 $/ساعة. توفير 80%.',
      heroTitle: 'مركز اتصال لموزمبيق — دعم لوسوفوني من الدار البيضاء',
      heroSubtitle: 'خدمة عملاء متميزة للسوق الموزمبيقي. توفير 80%.',
    },
    it: {
      title: 'Call Center Mozambico | Assistenza Lusofona | Call IT Dev',
      description: 'Call center per il Mozambico: agenti lusofoni, fuso CAT, CSAT 95%, da 3 $/h. 80% risparmio.',
      heroTitle: 'Call Center per il Mozambico — Supporto Lusofono da Casablanca',
      heroSubtitle: 'Assistenza premium per il mercato mozambicano. 80% in meno.',
    },
    pt: {
      title: 'Call Center Moçambique | Atendimento Lusófono | Call IT Dev',
      description: 'Call center para Moçambique: agentes lusófonos, fuso CAT, CSAT 95%, a partir de 3 $/h. 80% economia.',
      heroTitle: 'Call Center para Moçambique — Suporte Lusófono de Casablanca',
      heroSubtitle: 'Atendimento premium para o mercado moçambicano. 80% mais barato.',
    },
    nl: {
      title: 'Callcenter Mozambique | Portugeestalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Mozambique: Portugeestalige agenten, CAT-tijdzone, CSAT 95%, vanaf 3 $/u. 80% besparing.',
      heroTitle: 'Callcenter voor Mozambique — Portugeestalige Support vanuit Casablanca',
      heroSubtitle: 'Premium klantenservice voor de Mozambikaanse markt. 80% goedkoper.',
    },
    pl: {
      title: 'Call Center Mozambik | Portugalskojęzyczna Obsługa | Call IT Dev',
      description: 'Call center dla Mozambiku: portugalskojęzyczni agenci, strefa CAT, CSAT 95%, od 3 $/h. 80% oszczędności.',
      heroTitle: 'Call Center dla Mozambiku — Portugalskojęzyczne Wsparcie z Casablanki',
      heroSubtitle: 'Premiumowa obsługa klienta dla rynku mozambickiego. 80% taniej.',
    },
    tr: {
      title: 'Mozambik Çağrı Merkezi | Portekizce Müşteri Hizmetleri | Call IT Dev',
      description: 'Mozambik için çağrı merkezi: Portekizce konuşanlar, CAT saat dilimi, CSAT %95, 3 $/saatten başlayan.',
      heroTitle: 'Mozambik İçin Çağrı Merkezi — Kazablanka\'dan Portekizce Destek',
      heroSubtitle: 'Mozambik pazarı için premium müşteri deneyimi. %80 daha ucuz.',
    },
    sv: {
      title: 'Callcenter Moçambique | Portugisisktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Moçambique: portugisisktalande agenter, CAT-tidszon, CSAT 95%, från 3 $/h. 80% besparing.',
      heroTitle: 'Callcenter för Moçambique — Portugisisktalande Support från Casablanca',
      heroSubtitle: 'Premium kundtjänst för den moçambikiska marknaden. 80% billigare.',
    },
    da: {
      title: 'Callcenter Mozambique | Portugisisktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Mozambique: portugisisktalende agenter, CAT-tidszone, CSAT 95%, fra 3 $/t. 80% besparelse.',
      heroTitle: 'Callcenter til Mozambique — Portugisisktalende Support fra Casablanca',
      heroSubtitle: 'Premium kundeservice for det mozambikanske marked. 80% billigere.',
    },
    zh: {
      title: '莫桑比克呼叫中心 | 葡萄牙语客服外包 | Call IT Dev',
      description: '莫桑比克呼叫中心外包：葡萄牙语座席，CAT时区，CSAT 95%，3美元/小时起。节省80%。',
      heroTitle: '莫桑比克呼叫中心 — 卡萨布兰卡葡萄牙语支持',
      heroSubtitle: '以超低价格提供莫桑比克市场优质葡萄牙语客户服务。节省80%。',
    },
    ja: {
      title: 'モザンビークコールセンター | ポルトガル語カスタマーサポート | Call IT Dev',
      description: 'モザンビーク向けコールセンター：ポルトガル語話者、CAT時間帯、CSAT 95%、3$/時間〜。80%コスト削減。',
      heroTitle: 'モザンビーク向けコールセンター — カサブランカからのポルトガル語サポート',
      heroSubtitle: 'モザンビーク市場向けプレミアムポルトガル語顧客サービス。80%低コスト。',
    },
    ko: {
      title: '모잠비크 콜센터 | 포르투갈어 고객 서비스 | Call IT Dev',
      description: '모잠비크 콜센터 아웃소싱: 포르투갈어 상담원, CAT 시간대, CSAT 95%, 시간당 3달러부터. 80% 절감.',
      heroTitle: '모잠비크 콜센터 — 카사블랑카에서 포르투갈어 지원',
      heroSubtitle: '모잠비크 시장을 위한 프리미엄 포르투갈어 고객 서비스. 80% 저렴.',
    },
    ru: {
      title: 'Колл-центр Мозамбик | Португалоязычное обслуживание | Call IT Dev',
      description: 'Колл-центр для Мозамбика: португалоговорящие агенты, часовой пояс CAT, CSAT 95%, от 3 $/ч. Экономия 80%.',
      heroTitle: 'Колл-центр для Мозамбика — Португалоязычная поддержка из Касабланки',
      heroSubtitle: 'Премиум-обслуживание для мозамбикского рынка. На 80% дешевле.',
    },
  },

  // Gap-fill: Colombia missing languages
  colombia: {
    zh: {
      title: '哥伦比亚呼叫中心 | 西班牙语客服外包 | Call IT Dev',
      description: '哥伦比亚呼叫中心外包：西班牙语母语座席，COT时区，CSAT 95%，3美元/小时起。节省65%。',
      heroTitle: '哥伦比亚呼叫中心 — 卡萨布兰卡西班牙语支持',
      heroSubtitle: '以超低价格提供哥伦比亚市场优质西班牙语客户服务。节省65%。',
    },
    ja: {
      title: 'コロンビアコールセンター | スペイン語カスタマーサポート | Call IT Dev',
      description: 'コロンビア向けコールセンター：スペイン語ネイティブ、COT時間帯、CSAT 95%、3$/時間〜。65%コスト削減。',
      heroTitle: 'コロンビア向けコールセンター — カサブランカからのスペイン語サポート',
      heroSubtitle: 'コロンビア市場向けプレミアムスペイン語顧客サービス。65%低コスト。',
    },
    ko: {
      title: '콜롬비아 콜센터 | 스페인어 고객 서비스 | Call IT Dev',
      description: '콜롬비아 콜센터: 스페인어 원어민, COT 시간대, CSAT 95%, 시간당 3달러부터. 65% 절감.',
      heroTitle: '콜롬비아 콜센터 — 카사블랑카에서 스페인어 지원',
      heroSubtitle: '콜롬비아 시장을 위한 프리미엄 스페인어 고객 서비스. 65% 저렴.',
    },
    sv: {
      title: 'Callcenter Colombia | Spansktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Colombia: spansktalande agenter, COT-tidszon, CSAT 95%, från 3 $/h. 65% besparing.',
      heroTitle: 'Callcenter för Colombia — Spansktalande Support från Casablanca',
      heroSubtitle: 'Premium kundtjänst för den colombianska marknaden. 65% billigare.',
    },
    da: {
      title: 'Callcenter Colombia | Spansktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Colombia: spansktalende agenter, COT-tidszone, CSAT 95%, fra 3 $/t. 65% besparelse.',
      heroTitle: 'Callcenter til Colombia — Spansktalende Support fra Casablanca',
      heroSubtitle: 'Premium kundeservice for det colombianske marked. 65% billigere.',
    },
  },

  // Gap-fill: Nigeria missing languages
  nigeria: {
    zh: {
      title: '尼日利亚呼叫中心 | 英语客服外包 | Call IT Dev',
      description: '尼日利亚呼叫中心外包：英语母语座席，WAT时区，CSAT 95%，3美元/小时起。节省75%。',
      heroTitle: '尼日利亚呼叫中心 — 卡萨布兰卡英语支持',
      heroSubtitle: '以超低价格提供尼日利亚市场优质英语客户服务。节省75%。',
    },
    ja: {
      title: 'ナイジェリアコールセンター | 英語カスタマーサポート | Call IT Dev',
      description: 'ナイジェリア向けコールセンター：英語ネイティブ、WAT時間帯、CSAT 95%、3$/時間〜。75%コスト削減。',
      heroTitle: 'ナイジェリア向けコールセンター — カサブランカからの英語サポート',
      heroSubtitle: 'ナイジェリア市場向けプレミアム英語顧客サービス。75%低コスト。',
    },
    ko: {
      title: '나이지리아 콜센터 | 영어 고객 서비스 | Call IT Dev',
      description: '나이지리아 콜센터: 영어 원어민, WAT 시간대, CSAT 95%, 시간당 3달러부터. 75% 절감.',
      heroTitle: '나이지리아 콜센터 — 카사블랑카에서 영어 지원',
      heroSubtitle: '나이지리아 시장을 위한 프리미엄 영어 고객 서비스. 75% 저렴.',
    },
    sv: {
      title: 'Callcenter Nigeria | Engelsktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Nigeria: engelsktalande agenter, WAT-tidszon, CSAT 95%, från 3 $/h. 75% besparing.',
      heroTitle: 'Callcenter för Nigeria — Engelsktalande Support från Casablanca',
      heroSubtitle: 'Premium kundtjänst för den nigerianska marknaden. 75% billigare.',
    },
    da: {
      title: 'Callcenter Nigeria | Engelsktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Nigeria: engelsktalende agenter, WAT-tidszone, CSAT 95%, fra 3 $/t. 75% besparelse.',
      heroTitle: 'Callcenter til Nigeria — Engelsktalende Support fra Casablanca',
      heroSubtitle: 'Premium kundeservice for det nigerianske marked. 75% billigere.',
    },
  },

};
